export const APP_LOGIN_PATH = '/app/login'
export const DEFAULT_APP_AUTH_REDIRECT = '/app/backoffice'
export const APP_AUTH_REDIRECT_QUERY_KEY = 'redirect'

type AppRouteLike = {
  fullPath?: string
  path?: string
}

const CONTROL_CHARS = /[\u0000-\u001F\u007F]/

const getFirstString = (value: unknown) => {
  if (Array.isArray(value)) {
    return getFirstString(value[0])
  }

  return typeof value === 'string' ? value : ''
}

const decodeRedirectValue = (value: string) => {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export const normalizeAppAuthRedirect = (
  value: unknown,
  fallback = DEFAULT_APP_AUTH_REDIRECT
) => {
  const rawValue = getFirstString(value).trim()
  if (!rawValue) return fallback

  const decodedValue = decodeRedirectValue(rawValue).trim()
  if (
    !decodedValue ||
    CONTROL_CHARS.test(decodedValue) ||
    !decodedValue.startsWith('/') ||
    decodedValue.startsWith('//')
  ) {
    return fallback
  }

  let url: URL
  try {
    url = new URL(decodedValue, 'https://kendrick.paris')
  } catch {
    return fallback
  }

  const path = url.pathname.replace(/\/$/, '') || '/'
  // Bare /app only bounces to the backoffice, and it is not in the Supabase
  // redirect allow list: OAuth would fall back to site_url (production).
  if (
    path === '/app' ||
    path === APP_LOGIN_PATH ||
    path.startsWith(`${APP_LOGIN_PATH}/`) ||
    !(path === '/app' || path.startsWith('/app/')) ||
    path.startsWith('/fr/app')
  ) {
    return fallback
  }

  return `${url.pathname}${url.search}${url.hash}`
}

export const getAppAuthRedirectFromRoute = (
  route: AppRouteLike,
  fallback = DEFAULT_APP_AUTH_REDIRECT
) => normalizeAppAuthRedirect(route.fullPath || route.path || fallback, fallback)

export const buildAppLoginRedirectPath = (
  redirectTarget: unknown,
  options: { error?: string } = {}
) => {
  const query = new URLSearchParams()
  query.set(APP_AUTH_REDIRECT_QUERY_KEY, normalizeAppAuthRedirect(redirectTarget))

  if (options.error) {
    query.set('error', options.error)
  }

  return `${APP_LOGIN_PATH}?${query.toString()}`
}
